import { Row, Spin } from "antd";

export const Loader = () => {
  return (
    <Row className="global-loader h-100 justify-center align-center position-absolute z-10">
      <Spin size="large" />
    </Row>
  );
};
